export const typeFilters = {
  EQUALS: 'equals',
  RANGE: 'range',
  IN: 'in',
  CONTAINS: 'contains',
  NONE: '',
};

export default {
  EMPTY_FILTERS: null,
  typeFilters,
};
